// eslint-disable-next-line no-unused-vars
class ContentAudioPlayer {
  constructor(playerElement) {
    this.audioPlayer = playerElement;
    this.playButton = this.audioPlayer.querySelector('.play-button');
    this.pauseButton = this.audioPlayer.querySelector('.pause-button');
    this.replayButton = this.audioPlayer.querySelector('.replay-button');
    this.currentTimeDisplay = this.audioPlayer.querySelector('.current-time');
    this.audio = this.audioPlayer.querySelector('audio');
    this.progressInput = this.audioPlayer.querySelector('.progress-input');
    this.timePopup = this.audioPlayer.querySelector('.time-popup');

    this.initEventListeners();
  }

  initEventListeners() {
    this.playButton.addEventListener('click', () => this.play());
    this.pauseButton.addEventListener('click', () => this.pause());
    this.replayButton.addEventListener('click', () => this.replay());
    this.audio.addEventListener('ended', () => this.displayOnAudioEnd());
    this.audio.addEventListener('timeupdate', () => this.updateProgress());
    this.progressInput.addEventListener('input', () => this.seek());
    this.progressInput.addEventListener('mouseup', () => this.hideTimePopup());
    this.progressInput.addEventListener('touchend', () => this.hideTimePopup());
  }

  play() {
    this.audio.play();
    this.displayOnAudioPlay();
  }

  displayOnAudioPlay() {
    this.playButton.classList.add('hidden');
    this.pauseButton.classList.remove('hidden');
    this.replayButton.classList.add('hidden');
  }

  pause() {
    this.audio.pause();
    this.displayOnAudioPause();
  }

  displayOnAudioPause() {
    this.pauseButton.classList.add('hidden');
    this.playButton.classList.remove('hidden');
    this.replayButton.classList.add('hidden');
  }

  replay() {
    this.audio.currentTime = 0;
    this.audio.play();
    this.playButton.classList.add('hidden');
    this.replayButton.classList.add('hidden');
    this.pauseButton.classList.remove('hidden');
  }

  displayOnAudioEnd() {
    this.pauseButton.classList.add('hidden');
    this.playButton.classList.add('hidden');
    this.replayButton.classList.remove('hidden');
  }

  updateProgress() {
    this.progressInput.value =
      this.audio.duration > 0
        ? (this.audio.currentTime / this.audio.duration) * 100
        : 0;
    this.progressInput.style.background = `linear-gradient(to right, #99b7e1 ${this.progressInput.value}%, #e6e8e5 ${this.progressInput.value}%)`;
    this.currentTimeDisplay.textContent = this.formatTime(
      this.audio.currentTime
    );
  }

  seek() {
    const progress = this.progressInput.value / 100;
    this.audio.currentTime = progress * this.audio.duration;

    this.timePopup.style.display = 'block';
    const timePopupView = this.timePopup.querySelector('span');
    timePopupView.textContent = this.formatTime(this.audio.currentTime);

    const rect = this.progressInput.getBoundingClientRect();
    const thumbWidth = 20;
    const percentage =
      (this.progressInput.value - this.progressInput.min) /
      (this.progressInput.max - this.progressInput.min);
    const position = percentage * (rect.width - thumbWidth) + thumbWidth / 2;

    this.timePopup.style.left = `${position - 29}px`;
    if (progress === 1) {
      this.displayOnAudioEnd();
    } else {
      if (this.audio.paused) {
        this.displayOnAudioPause();
      } else {
        this.displayOnAudioPlay();
      }
    }
  }

  hideTimePopup() {
    this.timePopup.style.display = 'none';
  }

  formatTime(time) {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.content-audio-player').forEach(playerElement => {
    new ContentAudioPlayer(playerElement);
  });
});
